module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-starts-3-medium-eb5386d00105791879169f1127b89510.jpg";